
import MyBets from './MyBets';
export default MyBets;